import { render } from "./EnrolleeEditSpouseOnboardComponent.vue?vue&type=template&id=80ea7086&scoped=true"
import script from "./EnrolleeEditSpouseOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeEditSpouseOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeEditSpouseOnboardComponent.vue?vue&type=style&index=0&id=80ea7086&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80ea7086"]])

export default __exports__